import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.less'],
})
export class FileUploaderComponent implements OnInit {
  @Input() fileTypes: string = '';
  @Input() fileList: NzUploadFile[] = [];
  @Input() fileListRender: TemplateRef<{ $implicit: NzUploadFile[] }>;
  @Input() label: string = '';
  @Input() allowFilesLabel: string = '';
  @Input() allowMultiple: boolean = false;
  @Input() uploadLimit: number = 0;
  @Input() fileSizeLimit: number = 0;
  @Input() danger: boolean = false;
  @Input() disable: boolean = false;
  @ViewChild('button', { read: ElementRef }) fileUploaderButton: ElementRef;
  @Output() onFileChange: EventEmitter<NzUploadFile | NzUploadFile[]> =
    new EventEmitter<NzUploadFile | NzUploadFile[]>();

  constructor() {}

  ngOnInit(): void {}

  beforeUpload = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
    this.fileList = [];
    if (this.allowMultiple) {
      this.fileList = fileList;
      this.onFileChange.emit(fileList);
      return false;
    }
    this.fileList.push(file);
    this.onFileChange.emit(file);
    return false;
  };

  remove = (file: NzUploadFile) => {
    if (this.allowMultiple) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
      this.onFileChange.emit(this.fileList);
    } else {
      this.fileList = [];
      this.onFileChange.emit(null);
    }
  };
}
